import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Multiselect from "multiselect-react-dropdown";
import { Link } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import {
  getAllModulelist,
  getAllRolelist,
  getNewUser,
} from "../../../service/AddUser/AddUserService";
import { getAllDepartmentDetailslist } from "../../../service/Department/DepartmentService";
import Select from "react-select";
// import 'react-select/dist/react-select.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import SpinnerComponent from "../../components/SpinnerComponent";
import instance from "../../../WebApi/WebApi";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import { useTranslation } from "react-i18next";
import { getInvoiceSupplierListCommon } from "../../../service/Product/ProductService";
import "../authentication/Register.css";

const Add_user = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showpassword, setShowPassword] = useState("");
  const [password, setPassword] = useState("");
  const [showconfirmpassword, setShowConfirmPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { logo } = props;
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [getImage, setGetImage] = useState(null);
  const [getImageresult, setGetImageresult] = useState("");
  const [name, setName] = useState("");
  const [shortName, setShortName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [module, setModule] = useState([]);
  const [moduleById, setModuleById] = useState("");
  const [departmentList, setAllDepartmentList] = useState([]);
  const [businesUnitData, setAllBusinessUnit] = useState([]);
  const [search, setSearch] = useState("");
  const [department, setDepartment] = useState([]);
  const [business, setBusiness] = useState([]);
  const [overView, setOverView] = useState("");
  const [role, setRole] = useState("");
  const [roleList, setAllRoleList] = useState([]);
  const [selectedValues, setSelectedValues] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [accountKey, setAccountKey] = useState("");
  const [selectedValuesDepartment, setSelectedValuesDepartment] = useState([]);

  const [selectedFinalValues, setSelectedFinalValues] = useState([]);

  const [myArray, setMyArray] = useState([]);
  const [myArrayDepartment, setMyArrayDepartment] = useState([]);
  const [myArrayBusiness, setMyArrayBusiness] = useState([]);
  const [myRoleList, setMyRoleList] = useState([]);
  const [roleIds, setRoleIds] = useState([]);
  const [myArrayModule, setMyArrayModule] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moduleDropDownData, setModuleDropDownData] = useState([]);
  const [moduleIds, setModuleIds] = useState([]);
  const [hasUpperCase, setHasUpperCase] = useState(false);
  const [hasLowerCase, setHasLowerCase] = useState(false);
  const [hasNumber, setHasNumber] = useState(false);
  const [hasSpecialChar, setHasSpecialChar] = useState(false);
  const [minTenChars, setMinTenChars] = useState(false);

  // console.log(myArrayModule, "myArrayModule");

  const onPassword = (e) => {
    const value = e.target.value;
    setPassword(value);
    setHasUpperCase(/(?=.*[A-Z])/.test(value));
    setHasLowerCase(/(?=.*[a-z])/.test(value));
    setHasNumber(/(?=.*\d)/.test(value));
    setHasSpecialChar(/(?=.*[@$!%*?&])/.test(value));
    setMinTenChars(value.length >= 10);
    setPassword(e.target.value);
  };

  const onConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };
  const onName = (e) => {
    setName(e.target.value);
  };

  const onFirstName = (e) => {
    setFirstName(e.target.value);
  };

  const onLastName = (e) => {
    setLastName(e.target.value);
  };

  const onShortName = (e) => {
    setShortName(e.target.value);
  };

  const onEmail = (e) => {
    setEmail(e.target.value);
  };

  const onOverView = (e) => {
    setOverView(e.target.value);
  };

  async function getInvoiceSupplierDataList() {
    setIsLoading(true);
    getInvoiceSupplierListCommon().then(function (result) {
      const response = result?.data;
      // console.log("resposne5414654", response);
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);

      setIsLoading(false);
    });
  }

  const onModule = (moduleId) => {
    setMyArrayModule([]);
    moduleId?.map((d) => {
      if (myArrayModule.includes(d?.value)) {
        setMyArrayModule(myArrayModule);
      } else {
        myArrayModule.push(d?.value);
        setMyArrayModule(myArrayModule);
      }
    });
    setModuleById(moduleId);
    const ids = moduleId.map((d) => d?.value);
    setModuleIds(ids);
  };

  const getDepartmentList = async (id) => {
    const data = {
      businessUnitId: id,
    };
    const response = await instance.post(
      `/customer/department/list-department-business-id`,
      data
    );
    setAllDepartmentList(response?.data?.data?.departmentList);
    // console.log("resp----->", response);
  };

  // console.log("departmentList--->", departmentList);

  const onBusiness = (business) => {
    setMyArrayBusiness([]);
    business?.map((d) => {
      if (myArrayBusiness.includes(d?.value)) {
        setMyArrayBusiness(myArrayDepartment);
      } else {
        myArrayDepartment.push(d?.value);
        setMyArrayBusiness(myArrayDepartment);
      }
    });
    const ids = business?.map((d) => d.value);
    getDepartmentList(ids);
    setBusiness(business);
  };
  const onDepartment = (department) => {
    setMyArrayDepartment([]);
    department?.map((d) => {
      if (myArrayDepartment.includes(d?.departmentId)) {
        setMyArrayDepartment(myArrayDepartment);
      } else {
        myArrayDepartment.push(d?.departmentId);
        setMyArrayDepartment(myArrayDepartment);
      }
    });
    setDepartment(department);
  };

  // const onRole = (roles) => {
  //   // setSelectedValues(e.target.value);
  //   // setSelectedRole(e.target.options[e.target.selectedIndex].text);

  //   setMyRoleList([]);
  //   roles?.map((d) => {
  //     if (myRoleList.includes(d?.value)) {
  //       setMyRoleList(myArrayDepartment);
  //     } else {
  //       myRoleList.push(d?.value);
  //       setMyRoleList(myArrayDepartment);
  //     }
  //   });
  //   setMyRoleList(roles);
  // };

  const getModule = async (id) => {
    const response = await instance.get(
      `/customer/employee/list-module-by-role/${id}`
    );
    setModuleDropDownData(response?.data?.data?.moduleData);
    const moduleIds = response?.data?.data?.moduleData?.map((d) => d.moduleId);
    setModuleIds(moduleIds);
    // console.log("resp--->", response);
  };

  const onRole = (e) => {
    // console.log("eee->", e.target.value);
    setSelectedValues(e.target.value);
    getModule(e.target.value);
  };

  const onFile = (event) => {
    if (event["target"].files.length > 0) {
      const file = event["target"].files[0];
      // setUserData({...userData, profileImage : file});
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0],
      });
      setGetImage(file);
      setGetImageresult(file.name);
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file);
      //     reader.onload = (event) => {
      //         setGetImageresult(reader.result);
      //   };
    }
  };

  //MODULE LIST
  useEffect(() => {
    getModuleDataList();
    getInvoiceSupplierDataList();
  }, []);

  async function getModuleDataList() {
    setIsLoading(true);
    getAllModulelist().then(function (result) {
      const response = result?.data;
      setModule(
        response?.data?.moduleData.filter((item) => !(item?.type === "Users"))
      );
      setIsLoading(false);
    });
  }

  let moduleDropdown = <option>Loading...</option>;
  if (module && module.length > 0) {
    moduleDropdown = module?.map((moduleRow, index) => (
      <option value={moduleRow.id}>{moduleRow.type}</option>
    ));
  }

  //department list

  useEffect(() => {
    getDepartmentDataList();
    getBussinessUnit();
  }, []);

  async function getBussinessUnit() {
    setIsLoading(true);
    getAllIndustryDetailslist(search).then(function (result) {
      const response = result.data;
      // console.log("response+++++++", response);
      setAllBusinessUnit(response?.data);
      setIsLoading(false);
    });
  }
  async function getDepartmentDataList() {
    setIsLoading(true);
    getAllDepartmentDetailslist(search).then(function (result) {
      const response = result.data;
      // setAllDepartmentList(response?.data?.departmentList);
      setIsLoading(false);
    });
  }

  //ROLE LIST
  useEffect(() => {
    getRoleDataList();
  }, []);

  async function getRoleDataList() {
    setIsLoading(true);
    getAllRolelist().then(function (result) {
      const response = result.data;
      setAllRoleList(response?.data?.jobRoleList);
      setIsLoading(false);
    });
  }

  let roleDropdown = <option>Loading...</option>;
  if (roleList && roleList.length > 0) {
    roleDropdown = roleList
      .filter(
        (item) =>
          !(item.name === "VIRIDI Admin" || item.name === "Quality Manager") &&
          item.isDelete !== true
      )
      .map((roleRow, index) => (
        <option key={index} value={roleRow.id}>
          {roleRow.name}
        </option>
      ));
  }

  const moduleDrop = module?.map((moduleRow, index) => ({
    value: moduleRow.id,
    label: moduleRow.type,
  }));

  const businessDropdown = businesUnitData?.map((deptRow, index) => ({
    // <option value={roleRow.id}>{roleRow.name}</option>
    value: deptRow.id,
    label: deptRow.name,
  }));
  const departmentDrop = departmentList?.map((deptRow, index) => ({
    // <option value={roleRow.id}>{roleRow.name}</option>
    value: deptRow.id,
    businessUnitId: deptRow.BusinessUnitId,
    label: deptRow.name,
  }));
  const jobRoleDropdown = roleList?.map((role, index) => ({
    // <option value={roleRow.id}>{roleRow.name}</option>
    value: role.id,
    label: role.name,
  }));

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  // console.log("myArrayDepartment--->", department);

  const onAddNow = () => {
    const supplierIds = selectedOptions?.map((d) => ({ supplierId: d?.value }));
    let formData = new FormData();

    // console.log(myArrayModule, "myArrayModule")

    //  businessData:[{departmentId: 42,businessUnitId:1},{departmentId:3,businessUnitId:1},{departmentId:18,businessUnitId:11}]
    const businessData = department?.map((d) => ({
      departmentId: d?.value,
      businessUnitId: d?.businessUnitId,
    }));
    formData.append("profilePic", getImage);
    // formData.append("name", name);
    formData.append("shortName", shortName);
    formData.append("overview", overView);
    formData.append("phone", phone);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("userJobRoleId", selectedValues);
    formData.append("businessData", JSON.stringify(businessData));
    formData.append("moduleIds", [moduleIds]);
    formData.append("accountKey", accountKey);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("supplierIds", JSON.stringify(supplierIds));
    formData.append(
      "companyWebsiteUrl",
      JSON.parse(localStorage.getItem("gs3_User")).companyWebsiteUrl
    );
    formData.append(
      "companyName",
      JSON.parse(localStorage.getItem("gs3_User")).companyName
    );

    if (firstName === "") {
      toast.error("Please type your first name");
    } else if (lastName === "") {
      toast.error("Please type your last name");
    } else if (shortName === "") {
      toast.error("Please type your short name");
    } else if (email === "") {
      toast.error("Please type your email address");
    } else if (phone === "") {
      toast.error("Please type your phone number");
    }
    // else if (myArrayModule.length <= 0) {
    //     toast.error("Please select module")

    // }
    else if (myArrayDepartment.length <= 0) {
      toast.error("Please select Department");
    } else if (password === "") {
      toast.error("Please type your password");
    } else if (password.length < 10) {
      toast.error("Please type a 10-digit password");
    } else if (
      !/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
        password
      )
    ) {
      toast.error(
        "Password must have at least one uppercase letter, one lowercase letter, one special character, and one number"
      );
    } else if (confirmpassword === "") {
      toast.error("Please type confirm password");
    } else if (password != confirmpassword) {
      toast.error("Password and confirm password mismatch");
    } else if (!selectedValues) {
      toast.error("Please select job role");
    } else if (overView === "") {
      toast.error("Please type overview");
    } else {
      setIsLoading(true);
      getNewUser(formData, (r) => {
        // console.log(r, "response");
        if (r.success === true) {
          setIsLoading(false);
          toast.success(r.message);
          navigate("/user");
        } else {
          setIsLoading(false);
          // console.log("nononononono");
          toast.error(r.message);
        }
      });
    }
  };

  const onSuppliers = (e) => {
    setSelectedOptions(e);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain users">
        <Leftpanel breadcm={t("configuration")} />
        <div className="dbRight">
          <Header
            link="/user"
            title={`${t("configuration")} > ${t("user")} > ${t("add_users")}`}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase">
            <form autoComplete="off">
              <div className="browseimg">
                <div className="upld">
                  <label htmlFor="upload-button" className="uploadBtn">
                    {image.preview ? (
                      <img
                        src={image.preview}
                        alt="dummy"
                        width="300"
                        height="300"
                      />
                    ) : (
                      <>
                        <span className="fa-stack fa-2x">
                          <i className="fa-solid fa-plus"></i>
                        </span>
                      </>
                    )}
                    <span className="addbtn">
                      <i className="fa-solid fa-circle-plus"></i>
                    </span>
                  </label>
                  <input
                    type="file"
                    id="upload-button"
                    style={{ display: "none" }}
                    onChange={onFile}
                  />
                  <br />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Shortname">{t("short_name")}</label>
                  <input
                    type="text"
                    id="Shortname"
                    className="form-control"
                    placeholder={t("placeholder_short_name")}
                    name=""
                    onChange={onShortName}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="name">{t("first_name")}</label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    placeholder={t("placeholder_first_name")}
                    name=""
                    onChange={onFirstName}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="Shortname">{t("last_name")}</label>
                  <input
                    type="text"
                    id="Shortname"
                    className="form-control"
                    placeholder={t("placeholder_last_name")}
                    name=""
                    onChange={onLastName}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3 ">
                  <label htmlFor="email">{t("email")}</label>
                  <div className="checkmail">
                    <input
                      type="email"
                      id="email"
                      className="form-control"
                      placeholder={t("placeholder_email")}
                      name="email_field"
                      autoComplete="new-email"
                      onChange={onEmail}
                      defaultValue=""
                    />
                    <i className="fa-solid fa-circle-check"></i>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="phone">{t("phone")}</label>
                  <PhoneInput
                    defaultCountry="ua"
                    value={phone}
                    className="phInp"
                    name="phone"
                    onChange={(phone) => setPhone(phone)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="Department">{t("business_unit")}</label>
                  <Select
                    id="Department"
                    placeholder={t("business_unit")}
                    isMulti
                    options={businessDropdown}
                    value={business}
                    onChange={onBusiness}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="Department">{t("department")}</label>
                  <Select
                    id="Department"
                    placeholder={t("department")}
                    isMulti
                    options={departmentDrop}
                    value={department}
                    isDisabled={departmentList.length === 0}
                    onChange={onDepartment}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="password">{t("password")}</label>
                  <div className="showHide">
                    <input
                      className="form-control"
                      id="password"
                      name="password"
                      type={showpassword ? "text" : "password"}
                      placeholder={t("password")}
                      autoComplete="new-password"
                      onChange={onPassword}
                    />
                    <div
                      className="input-group-addon eyeAbs"
                      onClick={() => {
                        setShowPassword(!showpassword);
                      }}
                    >
                      {showpassword ? (
                        <span>
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </span>
                      ) : (
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="passwordStrength">
                    <span style={{ color: hasUpperCase ? "green" : "#7f7373" }}>
                      <input
                        type="checkbox"
                        checked={hasUpperCase}
                        readOnly
                        className="cursor-not-allowed"
                      />
                      A-Z
                    </span>
                    <span style={{ color: hasLowerCase ? "green" : "#7f7373" }}>
                      <input
                        type="checkbox"
                        checked={hasLowerCase}
                        readOnly
                        className="cursor-not-allowed"
                      />
                      a-z
                    </span>
                    <span style={{ color: hasNumber ? "green" : "#7f7373" }}>
                      <input
                        type="checkbox"
                        checked={hasNumber}
                        readOnly
                        className="cursor-not-allowed"
                      />
                      0-9
                    </span>
                    <span
                      style={{
                        color: hasSpecialChar ? "green" : "#7f7373",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={hasSpecialChar}
                        readOnly
                        className="cursor-not-allowed"
                      />
                      @#$%...
                    </span>
                    <span style={{ color: minTenChars ? "green" : "#7f7373" }}>
                      <input
                        type="checkbox"
                        checked={minTenChars}
                        readOnly
                        className="cursor-not-allowed"
                      />
                      Min 10 Characters
                    </span>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="confirmpassword">
                    {t("confirm_password")}
                  </label>
                  <div className="showHide">
                    <input
                      className="form-control"
                      name="conformpassword"
                      type={showconfirmpassword ? "text" : "password"}
                      id="confirmpassword"
                      placeholder={t("confirm_password")}
                      onChange={onConfirmPassword}
                    />
                    <div
                      className="input-group-addon eyeAbs"
                      onClick={() => {
                        setShowConfirmPassword(!showconfirmpassword);
                      }}
                    >
                      {showconfirmpassword ? (
                        <span>
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </span>
                      ) : (
                        <span>
                          <i className="fa fa-eye-slash" aria-hidden="true"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="GLorAccountingkey">{t("accounting_key")}</label>
                <input
                  type="text"
                  id="GLorAccountingkey"
                  className="form-control"
                  placeholder={t("placeholder_accounting_key")}
                  name="accountKey"
                  onChange={(e) => setAccountKey(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="role">{t("role")}</label>
                  <select className="form-control" id="role" onChange={onRole}>
                    {roleDropdown}
                  </select>
                </div>
                {Number(selectedValues) === 27 ? (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="module">{t("module")}</label>
                    <Select
                      isMulti
                      options={moduleDrop}
                      value={moduleById}
                      onChange={onModule}
                    />
                  </div>
                ) : (
                  <div className="col-md-6 mb-3">
                    <label htmlFor="module">{t("module")}</label>
                    <div
                      style={{
                        border: "1px solid #d5cfcf",
                        padding: "10px",
                        borderRadius: "5px",
                        minHeight: "43px",
                      }}
                    >
                      {moduleDropDownData?.map((data, i) =>
                        i === moduleDropDownData?.length - 1 ? (
                          <span>{` ${data?.modulename} `}</span>
                        ) : (
                          <span>{` ${data?.modulename} ,`}</span>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Overview">{t("overview")}</label>
                  <textarea
                    className="form-control"
                    id="Overview"
                    placeholder={t("placeholder_overview")}
                    onChange={onOverView}
                  ></textarea>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <label htmlFor="Supplier">{t("suppliers")}</label>
                  <Select
                    id="Supplier"
                    placeholder={t("select_supplier")}
                    isMulti
                    options={invoiceSupplierDataList?.map((item) => ({
                      label: item?.name,
                      value: item?.id,
                    }))}
                    value={selectedOptions}
                    onChange={onSuppliers}
                  />
                </div>
              </div>

              <button type="button" className="commonButton" onClick={onAddNow}>
                <Link>{t("add_now")}</Link>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add_user;
